import React from "react";
import { Modal, ModalContent, ModalBody, ModalHeader, ModalFooter } from "@heroui/modal";
// Components
import Button from "./layout/Button";

// ErrorBoundary Fallback component
const FallbackUserInterface: React.FC = () => {
  const reset = () => {
    // remove all Cognito items from localStorage
    Object.keys(localStorage)
      .filter((x) => x.startsWith("Cognito"))
      .forEach((x) => localStorage.removeItem(x));
    window.location.href = "/";
  };
  return (
    <Modal isOpen={true} isDismissable={false} isKeyboardDismissDisabled={false} hideCloseButton={true}>
      <ModalContent>
        {() => (
          <>
            <ModalHeader className="flex flex-col gap-1">Oh nee, dit gaat niet goed...</ModalHeader>
            <ModalBody>
              <p>Er is een fout opgetreden.</p>
            </ModalBody>
            <ModalFooter>
              <Button onClick={reset}>Herstarten</Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

// ErrorBoundary
type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
};

class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    console.error(error, info.componentStack);
  }

  render() {
    if (this.state.hasError) return <FallbackUserInterface />;
    return this.props.children;
  }
}

export default ErrorBoundary;
